import AedFlag from '~/icons/flags/AedFlag';
import AudFlag from '~/icons/flags/AudFlag';
import BdtFlag from '~/icons/flags/BdtFlag';
import BsdFlag from '~/icons/flags/BsdFlag';
import CadFlag from '~/icons/flags/CadFlag';
import ChfFlag from '~/icons/flags/ChfFlag';
import GbpFlag from '~/icons/flags/GbpFlag';
import InrFlag from '~/icons/flags/InrFlag';
import JpyFlag from '~/icons/flags/JpyFlag';
import MyrFlag from '~/icons/flags/MyrFlag';
import NgnFlag from '~/icons/flags/NgnFlag';
import NzdFlag from '~/icons/flags/NzdFlag';
import UsdFlag from '~/icons/flags/UsdFlag';
import VndFlag from '~/icons/flags/VndFlag';
import ZarFlag from '~/icons/flags/ZarFlag';

export const COUNTRIES = [
  { label: 'Afghanistan', value: 'Afghanistan', country_code: '+93' },
  { label: 'Albania', value: 'Albania', country_code: '+355' },
  { label: 'Algeria', value: 'Algeria', country_code: '+213' },
  { label: 'Andorra', value: 'Andorra', currency_value: 'EUR', country_code: '+376' },
  { label: 'Angola', value: 'Angola', country_code: '+244' },
  { label: 'Antartica', value: 'Antartica', country_code: '+672' },
  { label: 'Antigua and Barbuda', value: 'Antigua and Barbuda', country_code: '+1268' },
  { label: 'Argentina', value: 'Argentina', country_code: '+54' },
  { label: 'Armenia', value: 'Armenia', country_code: '+374' },
  { label: 'Aruba', value: 'Aruba', country_code: '+297' },
  { label: 'Australia', value: 'Australia', currency_value: 'AUD', country_code: '+61 Australia' },
  { label: 'Austria', value: 'Austria', currency_value: 'EUR', country_code: '+43' },
  { label: 'Azerbaijan', value: 'Azerbaijan', country_code: '+994' },
  { label: 'Bahamas', value: 'Bahamas', country_code: '+1242 Bahamas', currency_value: 'BSD' },
  { label: 'Bahrain', value: 'Bahrain', country_code: '+973' },
  {
    label: 'Bangladesh',
    value: 'Bangladesh',
    currency_value: 'BDT',
    country_code: '+880 Bangladesh',
  },
  { label: 'Barbados', value: 'Barbados', country_code: '+1246' },
  { label: 'Belarus', value: 'Belarus', country_code: '+375' },
  { label: 'Belgium', value: 'Belgium', currency_value: 'EUR', country_code: '+32' },
  { label: 'Belize', value: 'Belize', country_code: '+501' },
  { label: 'Benin', value: 'Benin', country_code: '+229' },
  { label: 'Bermuda', value: 'Bermuda', country_code: '+1441' },
  { label: 'Bhutan', value: 'Bhutan', country_code: '+975' },
  { label: 'Bolivia', value: 'Bolivia', country_code: '+591' },
  { label: 'Bosnia and Herzegovina', value: 'Bosnia and Herzegovina', country_code: '+387' },
  { label: 'Botswana', value: 'Botswana', country_code: '+267' },
  { label: 'Brazil', value: 'Brazil', country_code: '+55' },
  { label: 'British Virgin Islands', value: 'British Virgin Islands', country_code: '+1284' },
  { label: 'Brunei', value: 'Brunei', country_code: '+673' },
  { label: 'Bulgaria', value: 'Bulgaria', country_code: '+359' },
  { label: 'Burkina Faso', value: 'Burkina Faso', country_code: '+226' },
  { label: 'Burundi', value: 'Burundi', country_code: '+257' },
  { label: 'Cambodia', value: 'Cambodia', country_code: '+855' },
  { label: 'Cameroon', value: 'Cameroon', country_code: '+237' },
  { label: 'Canada', value: 'Canada', currency_value: 'CAD', country_code: '+1 Canada' },
  { label: 'Cape Verde', value: 'Cape Verde', country_code: '+238' },
  { label: 'Cayman Islands', value: 'Cayman Islands', country_code: '+1345' },
  { label: 'Central African Republic', value: 'Central African Republic', country_code: '+236' },
  { label: 'Chad', value: 'Chad', country_code: '+235' },
  { label: 'Chile', value: 'Chile', country_code: '+56' },
  { label: 'China', value: 'China', country_code: '+86' },
  { label: 'Christmas Island', value: 'Christmas Island', country_code: '+61' },
  { label: 'Cocos Islands', value: 'Cocos Islands', country_code: '+61' },
  { label: 'Colombia', value: 'Colombia', country_code: '+57' },
  { label: 'Comoros', value: 'Comoros', country_code: '+269' },
  { label: 'Congo (Congo-Brazzaville)', value: 'Congo (Congo-Brazzaville)', country_code: '+242' },
  { label: 'Costa Rica', value: 'Costa Rica', country_code: '+506' },
  { label: 'Croatia', value: 'Croatia', currency_value: 'EUR', country_code: '+385' },
  { label: 'Cuba', value: 'Cuba', country_code: '+53' },
  { label: 'Cyprus', value: 'Cyprus', currency_value: 'EUR', country_code: '+357' },
  { label: 'Czech Republic', value: 'Czech Republic', country_code: '+420' },
  {
    label: "Democratic People's Republic of Korea",
    value: "Democratic People's Republic of Korea",
    country_code: '+850',
  },
  {
    label: 'Democratic Republic of the Congo',
    value: 'Democratic Republic of the Congo',
    country_code: '+243',
  },
  { label: 'Denmark', value: 'Denmark', country_code: '+45' },
  { label: 'Djibouti', value: 'Djibouti', country_code: '+253' },
  { label: 'Dominica', value: 'Dominica', country_code: '+1767' },
  { label: 'Dominican Republic', value: 'Dominican Republic', country_code: '+1809' },
  { label: 'Ecuador', value: 'Ecuador', country_code: '+593' },
  { label: 'Egypt', value: 'Egypt', country_code: '+20' },
  { label: 'El Salvador', value: 'El Salvador', country_code: '+503' },
  { label: 'Equatorial Guinea', value: 'Equatorial Guinea', country_code: '+240' },
  { label: 'Eritrea', value: 'Eritrea', country_code: '+291' },
  { label: 'Estonia', value: 'Estonia', currency_value: 'EUR', country_code: '+372' },
  { label: 'Eswatini (Swaziland)', value: 'Eswatini (Swaziland)', country_code: '+268' },
  { label: 'Ethiopia', value: 'Ethiopia', country_code: '+251' },
  { label: 'Fiji', value: 'Fiji', country_code: '+679' },
  { label: 'Finland', value: 'Finland', currency_value: 'EUR', country_code: '+358' },
  { label: 'France', value: 'France', currency_value: 'EUR', country_code: '+33' },
  { label: 'French Guiana', value: 'French Guiana', currency_value: 'EUR', country_code: '+594' },
  { label: 'French Polynesia', value: 'French Polynesia', country_code: '+689' },
  {
    label: 'French Southern Territories',
    value: 'French Southern Territories',
    currency_value: 'EUR',
    country_code: '+262',
  },
  { label: 'Gabon', value: 'Gabon', country_code: '+241' },
  { label: 'Gambia', value: 'Gambia', country_code: '+220' },
  { label: 'Georgia', value: 'Georgia', country_code: '+995' },
  { label: 'Germany', value: 'Germany', currency_value: 'EUR', country_code: '+49' },
  { label: 'Ghana', value: 'Ghana', country_code: '+233' },
  { label: 'Greece', value: 'Greece', currency_value: 'EUR', country_code: '+30' },
  { label: 'Greenland', value: 'Greenland', country_code: '+299' },
  { label: 'Grenada', value: 'Grenada', country_code: '+1473' },
  { label: 'Guam (USA)', value: 'Guam (USA)', currency_value: 'USD', country_code: '+1671' },
  { label: 'Guatemala', value: 'Guatemala', country_code: '+502' },
  { label: 'Guinea', value: 'Guinea', country_code: '+224' },
  { label: 'Guinea-Bissau', value: 'Guinea-Bissau', country_code: '+245' },
  { label: 'Guyana', value: 'Guyana', country_code: '+592' },
  { label: 'Haiti', value: 'Haiti', country_code: '+509' },
  {
    label: 'Heard Island and McDonald Islands',
    value: 'Heard Island and McDonald Islands',
    country_code: '+672',
  },
  { label: 'Honduras', value: 'Honduras', country_code: '+504' },
  { label: 'Hong Kong', value: 'Hong Kong', country_code: '+852' },
  { label: 'Hungary', value: 'Hungary', country_code: '+36' },
  { label: 'Iceland', value: 'Iceland', country_code: '+354' },
  { label: 'India', value: 'India', currency_value: 'INR', country_code: '+91 India' },
  { label: 'Indonesia', value: 'Indonesia', country_code: '+62' },
  { label: 'Iran', value: 'Iran', country_code: '+98' },
  { label: 'Iraq', value: 'Iraq', country_code: '+964' },
  { label: 'Ireland', value: 'Ireland', currency_value: 'EUR', country_code: '+353' },
  { label: 'Israel', value: 'Israel', country_code: '+972' },
  { label: 'Italy', value: 'Italy', currency_value: 'EUR', country_code: '+39' },
  { label: 'Jamaica', value: 'Jamaica', country_code: '+1876' },
  { label: 'Japan', value: 'Japan', currency_value: 'JPY', country_code: '+81 Japan' },
  { label: 'Jersey', value: 'Jersey', country_code: '+44' },
  { label: 'Jordan', value: 'Jordan', country_code: '+962' },
  { label: 'Kazakhstan', value: 'Kazakhstan', country_code: '+7' },
  { label: 'Kenya', value: 'Kenya', country_code: '+254' },
  { label: 'Kiribati', value: 'Kiribati', country_code: '+686' },
  { label: 'Kuwait', value: 'Kuwait', country_code: '+965' },
  { label: 'Kyrgyzstan', value: 'Kyrgyzstan', country_code: '+996' },
  { label: 'Laos', value: 'Laos', country_code: '+856' },
  { label: 'Latvia', value: 'Latvia', currency_value: 'EUR', country_code: '+371' },
  { label: 'Lebanon', value: 'Lebanon', country_code: '+961' },
  { label: 'Lesotho', value: 'Lesotho', country_code: '+266' },
  { label: 'Liberia', value: 'Liberia', country_code: '+231' },
  { label: 'Libya', value: 'Libya', country_code: '+218' },
  { label: 'Liechtenstein', value: 'Liechtenstein', currency_value: 'CHF', country_code: '+423' },
  { label: 'Lithuania', value: 'Lithuania', currency_value: 'EUR', country_code: '+370' },
  { label: 'Luxembourg', value: 'Luxembourg', currency_value: 'EUR', country_code: '+352' },
  { label: 'Macau', value: 'Macau', country_code: '+853' },
  { label: 'Macedonia', value: 'Macedonia', country_code: '+389' },
  { label: 'Madagascar', value: 'Madagascar', country_code: '+261' },
  { label: 'Malawi', value: 'Malawi', country_code: '+265' },
  { label: 'Malaysia', value: 'Malaysia', currency_value: 'MYR', country_code: '+60 Malaysia' },
  { label: 'Maldives', value: 'Maldives', country_code: '+960' },
  { label: 'Mali', value: 'Mali', country_code: '+223' },
  { label: 'Malta', value: 'Malta', currency_value: 'EUR', country_code: '+356' },
  { label: 'Marshall Islands', value: 'Marshall Islands', country_code: '+692' },
  { label: 'Mauritania', value: 'Mauritania', country_code: '+222' },
  { label: 'Mauritius', value: 'Mauritius', country_code: '+230' },
  { label: 'Mayotte', value: 'Mayotte', currency_value: 'EUR', country_code: '+262' },
  { label: 'Mexico', value: 'Mexico', country_code: '+52' },
  { label: 'Micronesia', value: 'Micronesia', country_code: '+691' },
  { label: 'Moldova', value: 'Moldova', country_code: '+373' },
  { label: 'Monaco', value: 'Monaco', currency_value: 'EUR', country_code: '+377' },
  { label: 'Mongolia', value: 'Mongolia', country_code: '+976' },
  { label: 'Montenegro', value: 'Montenegro', currency_value: 'EUR', country_code: '+382' },
  { label: 'Morocco', value: 'Morocco', country_code: '+212' },
  { label: 'Mozambique', value: 'Mozambique', country_code: '+258' },
  { label: 'Myanmar (Burma)', value: 'Myanmar (Burma)', country_code: '+95' },
  { label: 'Namibia', value: 'Namibia', country_code: '+264' },
  { label: 'Nauru', value: 'Nauru', country_code: '+674' },
  { label: 'Nepal', value: 'Nepal', country_code: '+977' },
  { label: 'Netherlands', value: 'Netherlands', currency_value: 'EUR', country_code: '+31' },
  { label: 'New Caledonia', value: 'New Caledonia', country_code: '+687' },
  {
    label: 'New Zealand',
    value: 'New Zealand',
    currency_value: 'NZD',
    country_code: '+64 New Zealand',
  },
  { label: 'Nicaragua', value: 'Nicaragua', country_code: '+505' },
  { label: 'Niger', value: 'Niger', country_code: '+227' },
  { label: 'Nigeria', value: 'Nigeria', country_code: '+234 Nigeria', currency_value: 'NGN' },
  { label: 'North Korea', value: 'North Korea', country_code: '+850' },
  { label: 'North Macedonia', value: 'North Macedonia', country_code: '+389' },
  {
    label: 'Northern Mariana Islands (USA)',
    value: 'Northern Mariana Islands (USA)',
    currency_value: 'USD',
    country_code: '+1670',
  },
  { label: 'Norway', value: 'Norway', country_code: '+47' },
  { label: 'Oman', value: 'Oman', country_code: '+968' },
  { label: 'Pakistan', value: 'Pakistan', country_code: '+92' },
  { label: 'Palau', value: 'Palau', country_code: '+680' },
  { label: 'Palestine', value: 'Palestine', country_code: '+970' },
  { label: 'Panama', value: 'Panama', country_code: '+507' },
  { label: 'Papua New Guinea', value: 'Papua New Guinea', country_code: '+675' },
  { label: 'Paraguay', value: 'Paraguay', country_code: '+595' },
  { label: 'Peru', value: 'Peru', country_code: '+51' },
  { label: 'Philippines', value: 'Philippines', country_code: '+63' },
  { label: 'Pitcairn', value: 'Pitcairn', country_code: '+64' },
  { label: 'Poland', value: 'Poland', country_code: '+48' },
  { label: 'Portugal', value: 'Portugal', currency_value: 'EUR', country_code: '+351' },
  {
    label: 'Puerto Rico (USA)',
    value: 'Puerto Rico (USA)',
    currency_value: 'USD',
    country_code: '+1787',
  },
  { label: 'Qatar', value: 'Qatar', country_code: '+974' },
  { label: 'Republic Of Congo', value: 'Republic Of Congo', country_code: '+242' },
  { label: 'Réunion', value: 'Réunion', currency_value: 'EUR', country_code: '+262' },
  { label: 'Romania', value: 'Romania', country_code: '+40' },
  { label: 'Russia', value: 'Russia', country_code: '+7' },
  { label: 'Rwanda', value: 'Rwanda', country_code: '+250' },
  { label: 'Saint Kitts and Nevis', value: 'Saint Kitts and Nevis', country_code: '+1869' },
  { label: 'Saint Lucia', value: 'Saint Lucia', country_code: '+1758' },
  { label: 'Saint Martin', value: 'Saint Martin', currency_value: 'EUR', country_code: '+590' },
  {
    label: 'Saint Pierre and Miquelon',
    value: 'Saint Pierre and Miquelon',
    currency_value: 'EUR',
    country_code: '+508',
  },
  {
    label: 'Saint Vincent & Grenadines',
    value: 'Saint Vincent & Grenadines',
    country_code: '+1784',
  },
  { label: 'Samoa', value: 'Samoa', country_code: '+685' },
  { label: 'San Marino', value: 'San Marino', currency_value: 'EUR', country_code: '+378' },
  { label: 'São Tomé and Príncipe', value: 'São Tomé and Príncipe', country_code: '+239' },
  { label: 'Saudi Arabia', value: 'Saudi Arabia', country_code: '+966' },
  { label: 'Senegal', value: 'Senegal', country_code: '+221' },
  { label: 'Serbia', value: 'Serbia', country_code: '+381' },
  { label: 'Seychelles', value: 'Seychelles', country_code: '+248' },
  { label: 'Sierra Leone', value: 'Sierra Leone', country_code: '+232' },
  { label: 'Singapore', value: 'Singapore', country_code: '+65' },
  { label: 'Slovakia', value: 'Slovakia', currency_value: 'EUR', country_code: '+421' },
  { label: 'Slovenia', value: 'Slovenia', currency_value: 'EUR', country_code: '+386' },
  { label: 'Solomon Islands', value: 'Solomon Islands', country_code: '+677' },
  { label: 'Somalia', value: 'Somalia', country_code: '+252' },
  {
    label: 'South Africa',
    value: 'South Africa',
    currency_value: 'ZAR',
    country_code: '+27 South Africa',
  },
  {
    label: 'South Georgia and the South Sandwich Islands',
    value: 'South Georgia and the South Sandwich Islands',
    country_code: '+500',
  },
  { label: 'South Korea', value: 'South Korea', country_code: '+82' },
  { label: 'South Sudan', value: 'South Sudan', country_code: '+211' },
  { label: 'Spain', value: 'Spain', currency_value: 'EUR', country_code: '+34' },
  { label: 'Sri Lanka', value: 'Sri Lanka', country_code: '+94' },
  { label: 'Sudan', value: 'Sudan', country_code: '+249' },
  { label: 'Suriname', value: 'Suriname', country_code: '+597' },
  { label: 'Swaziland', value: 'Swaziland', country_code: '+268' },
  { label: 'Sweden', value: 'Sweden', country_code: '+46' },
  {
    label: 'Switzerland',
    value: 'Switzerland',
    currency_value: 'CHF',
    country_code: '+41 Switzerland',
  },
  { label: 'Syrian Arab Republic', value: 'Syrian Arab Republic', country_code: '+963' },
  { label: 'Taiwan', value: 'Taiwan', country_code: '+886' },
  { label: 'Tajikistan', value: 'Tajikistan', country_code: '+992' },
  { label: 'Tanzania', value: 'Tanzania', country_code: '+255' },
  { label: 'Thailand', value: 'Thailand', country_code: '+66' },
  { label: 'Timor-Leste', value: 'Timor-Leste', country_code: '+670' },
  { label: 'Togo', value: 'Togo', country_code: '+228' },
  { label: 'Tonga', value: 'Tonga', country_code: '+676' },
  { label: 'Trinidad and Tobago', value: 'Trinidad and Tobago', country_code: '+1868' },
  { label: 'Tunisia', value: 'Tunisia', country_code: '+216' },
  { label: 'Turkey', value: 'Turkey', country_code: '+90' },
  { label: 'Turkmenistan', value: 'Turkmenistan', country_code: '+993' },
  { label: 'Tuvalu', value: 'Tuvalu', country_code: '+688' },
  { label: 'Uganda', value: 'Uganda', country_code: '+256' },
  { label: 'Ukraine', value: 'Ukraine', country_code: '+380' },
  {
    label: 'United Arab Emirates',
    value: 'United Arab Emirates',
    currency_value: 'AED',
    country_code: '+971 United Arab Emirates',
  },
  {
    label: 'United Kingdom',
    value: 'United Kingdom',
    currency_value: 'GBP',
    country_code: '+44 United Kingdom',
  },
  {
    label: 'United States',
    value: 'United States',
    currency_value: 'USD',
    country_code: '+1 United States',
  },
  { label: 'Uruguay', value: 'Uruguay', country_code: '+598' },
  {
    label: 'US Virgin Islands (USA)',
    value: 'US Virgin Islands (USA)',
    currency_value: 'USD',
    country_code: '+1340',
  },
  { label: 'Uzbekistan', value: 'Uzbekistan', country_code: '+998' },
  { label: 'Vanuatu', value: 'Vanuatu', country_code: '+678' },
  { label: 'Vatican City', value: 'Vatican City', currency_value: 'EUR', country_code: '+379' },
  { label: 'Venezuela', value: 'Venezuela', country_code: '+58' },
  { label: 'Vietnam', value: 'Vietnam', currency_value: 'VND', country_code: '+84 Vietnam' },
  { label: 'Wallis and Futuna', value: 'Wallis and Futuna', country_code: '+681' },
  { label: 'Western Sahara', value: 'Western Sahara', country_code: '+212' },
  { label: 'Yemen', value: 'Yemen', country_code: '+967' },
  { label: 'Zambia', value: 'Zambia', country_code: '+260' },
  { label: 'Zimbabwe', value: 'Zimbabwe', country_code: '+263' },
];

export const COUNTRIES_CODES = [
  {
    label: '+1 United States',
    value: '+1 United States',
    logo: UsdFlag,
  },
  {
    label: '+1 Canada',
    value: '+1 Canada',
    logo: CadFlag,
  },
  {
    label: '+61 Australia',
    value: '+61 Australia',
    logo: AudFlag,
  },
  {
    label: '+44 United Kingdom',
    value: '+44 United Kingdom',
    logo: GbpFlag,
  },
  {
    label: '+64 New Zealand',
    value: '+64 New Zealand',
    logo: NzdFlag,
  },
  {
    label: '+27 South Africa',
    value: '+27 South Africa',
    logo: ZarFlag,
  },
  {
    label: '+91 India',
    value: '+91 India',
    logo: InrFlag,
  },
  {
    label: '+41 Switzerland',
    value: '+41 Switzerland',
    logo: ChfFlag,
  },
  {
    label: '+971 United Arab Emirates',
    value: '+971 United Arab Emirates',
    logo: AedFlag,
  },
  {
    label: '+81 Japan',
    value: '+81 Japan',
    logo: JpyFlag,
  },
  {
    label: '+84 Vietnam',
    value: '+84 Vietnam',
    logo: VndFlag,
  },
  {
    label: '+880 Bangladesh',
    value: '+880 Bangladesh',
    logo: BdtFlag,
  },
  {
    label: '+60 Malaysia',
    value: '+60 Malaysia',
    logo: MyrFlag,
  },
  {
    label: '+1242 Bahamas',
    value: '+1242 Bahamas',
    logo: BsdFlag,
  },
  {
    label: '+234 Nigeria',
    value: '+234 Nigeria',
    logo: NgnFlag,
  },
  {
    label: 'Other',
    value: '',
  },
];

export const getCurrencyByCountry = (countryName: string): string => {
  const country = COUNTRIES.find(
    country => country.label === countryName || country.value === countryName,
  );
  return country?.currency_value || 'USD';
};

export const getCountryCodeByCountryName = (countryName: string): string => {
  const country = COUNTRIES.find(
    country => country.label === countryName || country.value === countryName,
  );

  return country?.country_code || '';
};
